import { useQuery } from "@tanstack/react-query";

import DataSvc from "../../../../services/dataSvc";

interface UseFacilityReviewsProps {
  locationId: string;
  sort?: string;
  order?: string;
  limit?: number;
  offset?: number;
}

const useFacilityReviews = ({
  locationId,
  sort = "review_date",
  order = "desc",
  limit = 3,
  offset = 0
}: UseFacilityReviewsProps) => {
  const query = useQuery({
    queryKey: ["facilityReviews", locationId, sort, order, limit, offset],
    queryFn: () => {
      if (!locationId) return [];
      return DataSvc.getFacilityReviews({
        locationId: locationId,
        sort,
        order,
        limit,
        offset
      });
    },
    enabled: !!locationId
  });

  return query;
};

export default useFacilityReviews;
